<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const router = useRouter();
const { t } = useI18n();

const startZoomOutGame = () => {
  router.push({ name: 'ZoomOutGame' });
};

const startResolutionGame = () => {
  router.push({ name: 'ResolutionGame' });
};

const startNoiseGame = () => {
  router.push({ name: 'NoiseGame' });
};

const startMixGame = () => {
  router.push({ name: 'MixGame' });
};

const goBack = () => {
  router.push({ name: 'Home' });
};
</script>

<template>
  <div class="single-play-container">
    <h1>{{ t('home.single_play') }}</h1>
    <p>{{ t('home.select_game_mode') }}</p>
    <div class="game-mode-selection">
      <button @click="startMixGame" class="game-select-btn mix-btn">
        <div class="recommended-badge">{{ t('home.recommended') }}</div>
        <span class="btn-icon">🎨</span>
        <span class="btn-text">{{ t('home.start_mix_game') }}</span>
      </button>
      <button @click="startZoomOutGame" class="game-select-btn zoom-out-btn">
        <span class="btn-icon">🔍</span>
        <span class="btn-text">{{ t('home.start_zoom_out_game') }}</span>
      </button>
      <button @click="startResolutionGame" class="game-select-btn resolution-btn">
        <span class="btn-icon">🖼️</span>
        <span class="btn-text">{{ t('home.start_resolution_game') }}</span>
      </button>
      <button @click="startNoiseGame" class="game-select-btn noise-btn">
        <span class="btn-icon">🌫️</span>
        <span class="btn-text">{{ t('home.start_noise_game') }}</span>
      </button>
    </div>
    <div class="back-button-container">
      <button @click="goBack" class="back-button">{{ t('common.back') }}</button>
    </div>

    <div class="description-section">
      <h2>{{ t('single_play_selection.title') }}</h2>
      <p>{{ t('home.mode_desc_zoom_out') }}</p>
      <p>{{ t('home.mode_desc_resolution') }}</p>
      <p>{{ t('home.mode_desc_noise') }}</p>
      <p>{{ t('home.mode_desc_mix') }}</p>
    </div>
  </div>
</template>

<style scoped>
.single-play-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  box-sizing: border-box;
  font-family: 'Arial', sans-serif;
  background-color: #f0f2f5;
  color: #333;
}

h1 {
  font-size: 3rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  text-align: center;
}

.game-mode-selection {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-top: 2rem;
  width: 100%;
  max-width: 600px;
}

.game-select-btn {
  padding: 2rem 1rem;
  font-size: 1.3rem;
  color: #fff;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  gap: 0.8rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  width: 100%;
  position: relative;
}

.game-select-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
}

.btn-icon {
  font-size: 3rem;
}

.zoom-out-btn {
  background: linear-gradient(135deg, #42b983 0%, #369f6e 100%);
}

.resolution-btn {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
}

.noise-btn {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.mix-btn {
  background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
}

.recommended-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #ff4757;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: bold;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  transform: rotate(10deg);
  z-index: 10;
  border: 2px solid #fff;
}

.back-button-container {
  margin-top: 3rem;
}

.back-button {
  padding: 0.8rem 1.6rem;
  font-size: 1.2rem;
  color: #555;
  background-color: transparent;
  border: 2px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back-button:hover {
  background-color: #ddd;
  color: #333;
}

@media (max-width: 600px) {
  .game-mode-selection {
    grid-template-columns: 1fr;
    gap: 1rem;
    max-width: 300px;
  }
}

.description-section {
  margin-top: 3rem;
  max-width: 600px;
  text-align: center;
  background-color: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  width: 100%;
}

.description-section h2 {
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.description-section p {
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
}
</style>
